export enum LandingPageComponent {
  PurchaseOrders = 'wXCq',
  OpenAndPending = 'QwJ4',
  NewWidgetAvailable = 'rlVC',
  widgetsAre = 'Gzk1',
  widgetIs = 'bymd',
  ToCustomizeDashboard = 'ELgZ',
  TileSelectorLocation = 'q412',
  SelectedEventDeleted = '0Ze/',
  SelectedEventPending = 'AaPe',
}
